<template>
  <div class="documentation">
    <b-form @submit="addQuestion" >
      <form-wizard class="form-wizard-boxed-steps">
        <!-- Allow html in tab title (this template required for the proper styling) -->
        <template slot="step" slot-scope="props">
          <wizard-step :tab="props.tab" @click.native="props.navigateToTab(props.index)" @keyup.enter.native="props.navigateToTab(props.index)" :transition="props.transition" :index="props.index">
            <span slot="title" :class="{'text-danger':props.tab.validationError}" v-html="props.tab.title"></span>
          </wizard-step>
        </template>
        <tab-content title="<div class='small text-muted'>Etape 1</div>Paramètres généraux" :before-change="() => validateStep(1)">
          <b-alert  v-if="error" show variant="danger">
            {{ error }}
          </b-alert>
          <b-card class="mb-2">
            <b-form-group label="Type de question" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-select value="Choisir une catégorie de document" v-model="type" :options="typeData" @change="changeType($event)"/>
              <b-alert  v-if="errors['type']" show variant="danger">
                {{ errors['type'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group label="Tag" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-check-group v-model="tags" :options="tagData"/>
              <b-alert  v-if="errors['tags']" show variant="danger">
                {{ errors['tags'][0] }}
              </b-alert>
            </b-form-group>
          </b-card>
        </tab-content>
        <tab-content title="<div class='small text-muted'>Etape 2</div>Traductions" :before-change="() => validateStep(2)">
          <b-alert  v-if="error" show variant="danger">
            {{ error }}
          </b-alert>
          <b-card v-for="(traduction, index) in qtraductions" class="mb-2">
            <b-form-group label="Language" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-select v-if="index == 0" v-model="traduction.language" :options="mandatoryLanguageData"/>
              <b-select v-if="index != 0" v-model="traduction.language" :options="languageData"/>
              <b-alert  v-if="errors['type']" show variant="danger">
                {{ errors['type'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group label="Question" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
              <b-input type="text" placeholder="Label" v-model="traduction.label"/>
              <b-alert  v-if="errors['label']" show variant="danger">
                {{ errors['label'][0] }}
              </b-alert>
            </b-form-group>
            <b-form-group v-if="type !== 'TFREE'" label="Réponses" label-align-md="right"
                          label-class="pr-md-2" :label-cols-md="2">
              <b-alert  v-if="answers_err" show variant="danger">
                {{ answers_err }}
              </b-alert>
              <b-form-row v-for="question in traduction.answers" v-bind:key="question.value">
                <b-form-group>
                  <b-input type="text" placeholder="Valeur de la réponse" v-model="question.value"/>
                </b-form-group>
                <b-form-group class="ml-4">
                  <b-input type="text" placeholder="Texte de la réponse" v-model="question.label"/>
                </b-form-group>
              </b-form-row>
              <b-form-group>
                <b-btn v-on:click="addAnswer()" variant="success" v-if="type !== 'FOURANSWERS' && type !== 'ONETOTEN'">
                  Ajouter une réponse
                </b-btn>
              </b-form-group>
            </b-form-group>
          </b-card>
        </tab-content>
        <b-btn variant="default" slot="prev" class="mt-2">Retour</b-btn>
        <b-btn variant="default" slot="next" class="mt-2">Suivant</b-btn>
        <b-btn variant="warning" v-on:click="addTranslation" slot="finish" class="mt-2 mr-3 ml-3">Ajouter une traduction</b-btn>
        <b-btn type="submit" variant="primary" slot="finish" class="mt-2">Ajouter la question</b-btn>
      </form-wizard>
    </b-form>
  </div>
</template>
<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>
<style>
  .sweet-content{
    text-align:left !important;
  }
  .sweet-modal {
    background:#f5f5f5 !important;
  }
</style>
<script>
  import {
    ADMIN_ADD_QUESTION_REQUEST, ADMIN_GET_TAGS_REQUEST
  } from '../_store/administration/questionnary/actiontypes'
  import { mapState } from 'vuex';
  import {GET_LANGUAGES_REQUEST} from "../_store/translation/actiontypes";
  import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'

  export default {
    name: 'adminCategoryAdd',
    props: {
      language: {
        type: Array,
        required: true
      },
      source: {
        type: String,
        required: true
      },
      redirectUrl: {
        type: String,
        required: true
      },
      preData:{
        type: Object,
        required: false
      }
    },
    components: {FormWizard, TabContent, WizardStep},
    mounted() {
      this.$store.dispatch(ADMIN_GET_TAGS_REQUEST)
              .then(response => {
                this.tagData = response.data.tags.map(tag => {
                  return {
                    value: tag.id,
                    text: tag.label
                  }
                })
              })
      this.$store.dispatch(GET_LANGUAGES_REQUEST)
              .then(response => {
                this.languageData = response.data.languages.map(item => {
                  return {
                    "value": item.id,
                    "text": item.name
                  }
                });
                this.mandatoryLanguageData = this.languageData.slice(0, 2)
              })
    },
    computed: {
      ...mapState({
        errors: state => state.admin_questionnary.errors,
        user: state => state.user.user,
      })
    },
    data() {
      return ({
        error : false,
        languageData : [],
        mandatoryLanguageData: [],
        qtraductions: false,
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des questions', href: '/dashboard/administration/questionnary/' },
          { text: 'Ajouter une question', active: true },
        ],
        answers_err : '',
        label_en: '',
        label: '',
        is_mandatory: false,
        tagData: [],
        tags: [],
        answers: [
          {
            value: '',
            text: '',
            text_en: ''
          }
        ],
        type: null,
        typeData: [
          {
            value: null,
            text: ''
          },
          {
            value: 'YESNO',
            text: 'Oui / non'
          },
          {
            value: 'FOURANSWERS',
            text: '4 modalités'
          },
          {
            value: 'ONETOTEN',
            text: '1 à 10'
          },
          {
            value: 'TFREE',
            text: 'Réponse libre'
          }, {
            value: 'TSING',
            text: 'Choix Unique'
          }, {
            value: 'TMULT',
            text: 'Choix Multiple'
          }
        ]
      })
    },
    layout(context) {
      return 'layout'
    },
    methods: {
      validateStep: function(step) {
        if (step === 1) {
          if (this.type && this.tags && this.tags.length > 0) {
            return true
          }
          else {
            this.error = "Veuillez remplir l'ensemble des champs du formulaire";
            return false;
          }
        } else {
          if (this.qtraductions.length < 2) {
            this.error = "Veuillez remplir au moins deux langues distinctes";
          }
          else {
            if (this.qtraductions[0].language === this.qtraductions[1].language) {
              this.error = "Veuillez remplir au moins deux langues distinctes";
              return false;
            }
            else{
              return true;
            }
          }
        }
      },
      addTranslation: function() {
        console.log("I HAD TRANSLATION");
        let answers = this.qtraductions[0].answers;
        this.qtraductions.push({
          language: 0,
          answers: answers.map(answer => {
            answer.text = '';
            return answer;
          }),
          label: ""
        });
      },
      changeType: function(e) {
        console.log(this.language);
        if (this.qtraductions === false){
          this.qtraductions = [{
            language: this.user.userprofile.language.id,
            answers: [],
            label: "",
          }]
          this.language.map(language => {
            if (this.user.userprofile.language.id !== language){
                this.qtraductions.push({
                  language: language,
                  answers: [],
                  label: "",
                })
            }
          })
        }
        this.qtraductions = this.qtraductions.map(traduction => {
          if (this.type === 'YESNO') {
            if (traduction.language == 1) {
              traduction.answers = [
                {value: 'no', label: 'Non'},
                {value: 'yes', label: 'Oui'},
              ]
            } else if (traduction.language == 2) {
              traduction.answers = [
                {value: 'no', label: 'No'},
                {value: 'yes', label: 'Yes'},
              ]
            } else {
                traduction.answers = [
                  {value: 'no', label: ''},
                  {value: 'yes', label: ''},
                ]
            }
          }
          else if (this.type === 'FOURANSWERS') {
            if (traduction.language == 1) {
              traduction.answers = [
                {value: '1', label: 'Tout à fait d\'accord'},
                {value: '2', label: 'Plutôt d\'accord'},
                {value: '3', label: 'Plutôt pas d\'accord'},
                {value: '4', label: 'Pas du tout d\'accord'},
                {value: '5', label: 'Non concerné(e)'},
              ]
            } else if (traduction.language == 2) {
              traduction.answers = [
                {value: '1', label: 'Strongly agree'},
                {value: '2', label: 'Agree'},
                {value: '3', label: 'Disagree'},
                {value: '4', label: 'Strongly Disagree'},
                {value: '5', label: 'Not concerned'},
              ]
            } else {
              traduction.answers = [
                {value: '1', label: ''},
                {value: '2', label: ''},
                {value: '3', label: ''},
                {value: '4', label: ''},
                {value: '5', label: ''},
              ]
            }

          }
          else if (this.type === 'ONETOTEN') {
            traduction.answers = [
              {value: '1', label: '1'},
              {value: '2', label: '2'},
              {value: '3', label: '3'},
              {value: '4', label: '4'},
              {value: '5', label: '5'},
              {value: '6', label: '6'},
              {value: '7', label: '7'},
              {value: '8', label: '8'},
              {value: '9', label: '9'},
              {value: '10', label: '10'},
            ]
          }
          return traduction;
        });
      },
      addQuestion: function(e) {
        e.preventDefault();
        if (this.type === 'YESNO') {
          this.type = 'TSING';
        }
        else if (this.type === 'FOURANSWERS') {
          this.type = 'TSING';
        }
        else if (this.type === 'ONETOTEN') {
          this.type = 'TSING';
        }
        let source = "COMM";
        if (this.$route.params.core === 'core')
          source = "CORE";
        this.$store.dispatch(ADMIN_ADD_QUESTION_REQUEST, {
          tags: this.tags,
          qtranslations: this.qtraductions,
          type: this.type,
          source: this.source,
          is_mandatory: this.is_mandatory
        })
                .then(() => {
                  this.$emit('exit', true);
                  this.$router.push(this.redirectUrl);
                })
                .catch((error) => {
                  this.error = "Veuillez remplir au moins deux langues distinctes";
                });

      },
      addAnswer: function() {
        this.qtraductions = this.qtraductions.map(translation => {
          translation.answers.push({
            value: '',
            label: ''
          });
          return translation;
        });
      }
    }
  }
</script>
